{
  "title": "Silvery Barbs",
  "source": "Strixhaven: A Curriculum of Chaos",
  "levelAndSchool": "1st-level Enchantment",
  "level": 1,
  "castingTime": "1 reaction, which you take when a creature you can see within 60 feet of yourself succeeds on an attack roll, an ability check, or a saving throw",
  "range": "60 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You magically distract the triggering creature and turn its momentary uncertainty into encouragement for another creature. The triggering creature must reroll the d20 and use the lower roll.",
    "You can then choose a different creature you can see within range (you can choose yourself). The chosen creature has advantage on the next attack roll, ability check, or saving throw it makes within 1 minute. A creature can be empowered by only one use of this spell at a time."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "wizard"]
}
